var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4989 3H16.4989C17.8367 3 19.1196 3.52678 20.0655 4.46447C21.0114 5.40215 21.5428 6.67392 21.5428 8V16C21.5428 17.3261 21.0114 18.5979 20.0655 19.5355C19.1196 20.4732 17.8367 21 16.4989 21H16.4989C15.8366 21 15.1807 20.8707 14.5687 20.6194C13.9568 20.3681 13.4008 19.9998 12.9324 19.5355C12.464 19.0712 12.0925 18.5201 11.839 17.9134C11.5855 17.3068 11.4551 16.6566 11.4551 16V7.99999C11.4551 6.67391 11.9865 5.40214 12.9324 4.46446C13.8783 3.52678 15.1612 3 16.4989 3V3Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 25V29",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5236 17C25.2753 19.2002 24.2177 21.2324 22.553 22.7082C20.8883 24.1841 18.7334 25 16.5001 25C14.2668 25 12.1118 24.1841 10.4472 22.7082C8.7825 21.2324 7.72491 19.2001 7.47656 17",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudio);
export default __webpack_public_path__ + "static/media/icon-audio.6e4fb8c72235b13d5f282e31e4dc79fc.svg";
export { ForwardRef as ReactComponent };